export const findIssueInInspectionByQuestion = (issues: Array<{ inspection_question_uuid: string }>, questionUuid: string) =>
  issues.find(row => extractQuestionUuidFromComposedUuid(row) === questionUuid);

export const extractQuestionUuidFromComposedUuid = (issue: { inspection_question_uuid: string }) => {
  const splitUuid = issue.inspection_question_uuid ? issue.inspection_question_uuid.split('-') : [];

  return splitUuid.slice(1, 6).join('-');
};
